import React, {useContext, useEffect, useState} from "react";
import {ChartContext} from "../providers";
import {SettingsContext} from "../../providers";
import {AxisLabel, Legend} from ".";
import {TimeAxis} from "../../../img";
import {getDefaultParams} from "../config";


const ChartContainer = React.forwardRef(({}, ref) => {
    const {chart, active} = useContext(ChartContext);
    const settings = useContext(SettingsContext);

    const [state, setState] = useState({
        imgY: undefined, labelY: undefined, imgX: <TimeAxis/>, labelX: undefined
    })

    useEffect(() => {
        if (!chart) return;

        function onResize() {
            chart.setDefaults(getDefaultParams(window.innerWidth))
        }

        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('resize', onResize)
        }
    }, [chart])

    useEffect(() => {
        if (!chart || !active) return;
        const labelY = chart.chartOptions[active].options.scales.y.title.text
        const labelX = chart.chartOptions[active].options.scales.x.title.text
        setState(state => ({...state, labelY: labelY, labelX: labelX, imgY: <img src={settings.charts[active].axis_img}/>}))
    }, [active])


    return (
        <div className={'ulopolis-canvas-container'}>
            <div className={'ulopolis-canvas-left'}>
                <AxisLabel img={state.imgY} label={state.labelY} vertical={true}/>
            </div>
            <div className={'ulopolis-canvas-center'}>
                <canvas ref={ref} id={'ulopolis_chart'}/>
            </div>
            <div className={'ulopolis-canvas-bottom'}>
                <AxisLabel img={state.imgX} label={state.labelX}/>
                <Legend chart={chart}/>
            </div>
        </div>
    )
})

export default ChartContainer;